// extracted by mini-css-extract-plugin
export default {"submitBtnCol":"AddOrEditModal_submitBtnCol__SHC9c","submitBtn":"AddOrEditModal_submitBtn__fvCYu","rowReverse":"AddOrEditModal_rowReverse__7AeWM"};